<template>
  <div id="skills-candidate">
    <div class="create-profile-step-container">
      <step-title
        :title="title"
        :subtitle="subtitle"
        :icon="icon"
      />
      <form @submit.prevent="addNewSkill(skillsAutoComplete[highlightedSkillIndex])">
        <div class="field">
          <!--<label class="label">Enter Skills</label>-->
          <div
            class="control"
            :class="autoCompleteIsLoading ? 'is-loading' : ''"
          >
            <input
              v-model="newSkill"
              class="input"
              type="text"
              placeholder="Ex: Data Science"
              @keyup="debouncedSkillSearch($event)"
              @focus="inputIsFocused = true"
              @blur="inputIsFocused = false"
              @keyup.up="keyboardUp()"
              @keyup.down="keyboardDown()"
            >
            <ul
              v-if="skillsAutoComplete.length > 0 && newSkill.length > 0"
              class="autocomplete"
            >
              <li
                v-for="(skill, index) in skillsAutoComplete"
                :key="skill.key"
                :class="index === highlightedSkillIndex ? 'is-highlighted' : ''"
                @click="addNewSkill(skill)"
                @mouseover="highlightSkill(index)"
              >
                {{ skill }}
              </li>
            </ul>
          </div>
        </div>
      </form>
      <div class="card card-content tags-card">
        <p
          v-if="skills.length === 0"
          class="has-text-centered has-text-grey-light"
        >
          Nothing here yet...
        </p>
        <span
          v-for="(skill, index) in skills"
          :key="skill.key"
          class="tag is-primary is-rounded is-medium"
        >
          {{ skill }}
          <button
            class="delete is-small is-rounded"
            @click="removeSkill(index)"
          />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash-es';
import StepTitle from './StepTitle';

export default {
  name: 'SkillsCandidate',
  components: {
    StepTitle
  },
  data () {
    return {
      title: 'Skills',
      subtitle: 'Show your worth. We recommend at least 10!',
      icon: 'fa-user-check',
      newSkill: '',
      skillsAutoComplete: [],
      skills: [],
      highlightedSkillIndex: 0,
      inputIsFocused: false,
      autoCompleteIsLoading: false
    };
  },
  computed: {
    isFormValid () {
      return this.skills.length > 0;
    }
  },
  created () {
    this.skills = this.$store.state.user.profile.skills;
  },
  mounted () {
    this.checkForm();
  },
  updated () {
    this.checkForm();
    this.skills = this.$store.state.user.profile.skills;
  },
  methods: {
    addNewSkill (skill) {
      this.checkForm();
      if (this.isSkillDuplicate(skill)) {
        this.showDuplicateError();
        return;
      }
      this.skills.push(skill);
      this.newSkill = '';
      this.skillsAutoComplete = [];
      this.highlightedSkillIndex = 0;
      this.inputIsFocused = false;
      this.$store.commit('EDIT_CANDIDATE_SKILLS', this.skills);
    },

    removeSkill (index) {
      if (index > -1) {
        this.skills.splice(index, 1);
      }
      this.checkForm();
      this.$store.commit('EDIT_CANDIDATE_SKILLS', this.skills);
    },

    debouncedSkillSearch: debounce(function ($event) {
      this.searchForSkills($event);
    }, 200),

    searchForSkills ($event) {
      /* If user presses UP or DOWN keys, the search will NOT run.
            This prevents running searches when user is trying to navigate
            dropdown options. */
      if ($event.code === 'ArrowUp' || $event.code === 'ArrowDown') {
        return;
      }

      if (this.newSkill.length > 1) {
        this.autoCompleteIsLoading = true;
        /* We use the current query as the first result to allow the
                user to select their written option */
        this.skillsAutoComplete = [this.newSkill];
        this.$store.dispatch('getSkills', this.newSkill)
          .then(response => {
            // Here we concatenate the user's query with all other results.
            let skillsResults = this.skillsAutoComplete.concat(
              response.data.data.skill
            );
            this.skillsAutoComplete = skillsResults;
            if (response.data.data.skill.includes(this.newSkill)) {
              this.skillsAutoComplete.shift(); // Remove duplicate result if query is found in results array.
            }
            this.autoCompleteIsLoading = false;
          })
          .catch(error => console.log(error));
      }
    },

    highlightSkill (index) {
      this.highlightedSkillIndex = index;
    },

    keyboardDown () {
      this.highlightedSkillIndex++;
    },

    keyboardUp () {
      this.highlightedSkillIndex--;
    },

    isSkillDuplicate (newSkill) {
      let lowerCaseSkill = newSkill.toLowerCase();
      let skills = this.skills.map(str => str.toLowerCase());
      return skills.indexOf(lowerCaseSkill) !== -1;
    },

    showDuplicateError () {
      this.$toasted.show('You already have this skill on your profile');
    },

    checkForm () {
      setTimeout(() => {
        this.$emit('checkForm', this.isFormValid);
      }, 50);
    }
  }
};
</script>

<style lang="scss" scoped>
.tags-card {
  margin-top: 2rem;
  border-radius: 4px;
  box-shadow: 0 2px 6px 0 rgba(77, 101, 117, 0.25);
  margin-bottom: 1rem;
  padding: 2rem;
  box-sizing: border-box;
}

.tag {
  margin: 0.25rem;
}

.autocomplete {
  position: absolute;
  z-index: 10;
  background-color: white;
  width: 100%;
  max-height: 150px;
  overflow: scroll;
  border: 1px solid $primary;
  border-top: none;
  margin-top: -1px;
  transition: all 0.2s ease;
}

.is-highlighted {
  background-color: $primary;
  color: white;
  transition: all 0.2s ease;
}

li {
  padding: 0 0.5rem;
  cursor: pointer;
}
</style>
